<template>
  <div class="single-select" ref="wrapper">
    <div class="trigger" @click="toggle">
      <span>{{ selectedLabel }}</span>
    </div>

    <div class="dropdown" v-if="open">
      <div
        class="option"
        :class="{'selected' : item.id === value}"
        v-for="item in items"
        :key="item.id"
        @click="select(item)"
      >
        {{ item.text }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    items: { type: Array, required: true },
    value: { type: String, default: '' },
    placeholder: { type: String, default: '並び替え:' }
  },
  data () {
    return { open: false }
  },
  computed: {
    selectedLabel () {
      const f = this.items.find(i => i.id === this.value)
      return f ? this.placeholder + ' ' + f.text : ''
    }
  },
  methods: {
    toggle () {
      this.open = !this.open
    },
    close () {
      this.open = false
    },
    select (item) {
      this.$emit('input', item.id)
      this.close()
    },
    clickOutside (e) {
      if (!this.$refs.wrapper.contains(e.target)) this.close()
    }
  },
  mounted () {
    document.addEventListener('click', this.clickOutside)
  },
  beforeDestroy () {
    document.removeEventListener('click', this.clickOutside)
  }
}
</script>

<style scoped>
.single-select {
  position: relative;
  width: 220px;
  min-width: max-content;
}
.trigger {
  padding: 6px 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  background: #fff;
  cursor: pointer;
}
.dropdown {
  position: absolute;
  margin-top: 4px;
  border: 1px solid #ccc;
  background: #fff;
  width: 100%;
  z-index: 20;
}
.option {
  padding: 6px 10px;
  cursor: pointer;
}
.option.selected {
  background-color: #ccc;
}
.option:hover {
  background: #eee;
}
.placeholder { color: #888; }
@media (max-width: 425px) {
  .single-select {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/SingleSelect.vue